<template>
  <v-container>
    <v-row>
      <template v-for="(obj, idx) in localValue">
        <v-col :key="`option-text-${idx}`" cols="6">
          <v-text-field v-model="obj.text" label="Text" dense></v-text-field>
        </v-col>
        <v-col :key="`option-value-${idx}`" cols="6">
          <v-text-field v-model="obj.value" label="Value" dense></v-text-field>
        </v-col>
      </template>
    </v-row>
    <v-btn @click="addOption">Add option</v-btn>
  </v-container>
</template>

<script>
export default {
  name: 'TypeOptionsEditor',
  props: {
    value: {
      required: true,
      type: Array,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
  methods: {
    addOption() {
      this.localValue.push({ text: '', value: '' })
    },
  },
}
</script>
